import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Helper untuk format mata uang
const formatCurrency = (number) => {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(number);
};

// Komponen Card untuk menampilkan data
const StatCard = ({ title, value, color }) => (
    <div style={{
        background: color || '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        flex: 1,
        minWidth: '200px',
        margin: '10px'
    }}>
        <h3 style={{ margin: 0, fontSize: '16px', color: '#555' }}>{title}</h3>
        <p style={{ margin: '8px 0 0', fontSize: '28px', fontWeight: 'bold', color: '#333' }}>{value}</p>
    </div>
);

const Dashboard = () => {
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSummary = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }

            try {
                const config = {
                    headers: {
                        'x-auth-token': token,
                    },
                };
                const res = await axios.get('https://planstopia-production.up.railway.app/api/reports/summary', config);
                setSummary(res.data);
            } catch (err) {
                setError('Gagal mengambil data ringkasan. Silakan coba lagi.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchSummary();
    }, [navigate]);
    
    const user = JSON.parse(localStorage.getItem('user'));
    
    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
    };

    if (loading) {
        return <div style={styles.container}><h2>Memuat data...</h2></div>;
    }

    if (error) {
        return <div style={styles.container}><p style={{color: 'red'}}>{error}</p></div>;
    }

    return (
        <div style={styles.page}>
            {/* Simple Navbar */}
            <header style={styles.navbar}>
                <h1>Invoice App</h1>
                <div>
                    <span>Selamat datang, {user?.name || 'Pengguna'}!</span>
                    <button onClick={handleLogout} style={styles.logoutButton}>Logout</button>
                </div>
            </header>

            {/* Main Content */}
            <main style={styles.container}>
                <h2 style={{alignSelf: 'flex-start'}}>Dashboard Ringkasan</h2>
                <div style={styles.statsGrid}>
                    <StatCard 
                        title="Total Pendapatan" 
                        value={formatCurrency(summary.totalRevenue)} 
                        color="#e0f2f1"
                    />
                    <StatCard 
                        title="Total Terutang" 
                        value={formatCurrency(summary.totalOutstanding)}
                        color="#fff3e0"
                    />
                     <StatCard 
                        title="Invoice Belum Dibayar" 
                        value={summary.outstandingInvoices}
                        color="#ffebee"
                    />
                    <StatCard 
                        title="Total Semua Invoice" 
                        value={summary.totalInvoices}
                        color="#e3f2fd"
                    />
                </div>
                <div style={styles.actions}>
                    <button onClick={() => navigate('/invoices/new')} style={styles.actionButton}>Buat Invoice Baru</button>
                    <button onClick={() => navigate('/invoices')} style={styles.actionButton}>Lihat Semua Invoice</button>
                </div>
            </main>
        </div>
    );
};


// CSS-in-JS untuk styling
const styles = {
    page: {
        fontFamily: 'Arial, sans-serif',
        background: '#f9fafb',
        minHeight: '100vh',
    },
    navbar: {
        background: '#fff',
        padding: '0 20px',
        borderBottom: '1px solid #ddd',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '60px',
    },
    logoutButton: {
        marginLeft: '15px',
        padding: '8px 12px',
        background: '#dc3545',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer'
    },
    container: {
        padding: '20px 40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    statsGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1200px',
        margin: '20px 0',
    },
    actions: {
        marginTop: '30px',
    },
    actionButton: {
        margin: '0 10px',
        padding: '12px 24px',
        fontSize: '16px',
        background: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    }
};

export default Dashboard;
